import { FC, memo, useCallback, useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { VerificationAppDocumentType } from "../../models";
import { ALL_STEP_TYPES } from "./helpers";
import { StepTypeChip } from "./StepTypeChip";

export const AddStepButton: FC<{
  onAdd: (type: VerificationAppDocumentType) => void;
}> = memo(({ onAdd }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handlePick = useCallback(
    (type: VerificationAppDocumentType) => {
      onAdd(type);
      setAnchorEl(null);
    },
    [onAdd],
  );

  return (
    <>
      <Button variant='outlined' onClick={handleOpen}>
        Add step
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {ALL_STEP_TYPES.map((t) => (
          <MenuItem key={t} onClick={() => handlePick(t)} dense>
            <StepTypeChip type={t} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
});
